
























































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required, email } from 'vuelidate/lib/validators';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  validations: {
    emailSecurity: {
      dataCenter: { required },
      autoDomain: { required },
      adminEmail: { required, email },
      companyName: { required },
    },
  },
})
export default class ManageEmailSecurity extends SwExtendedVue {
  @Prop()
  showEmailSecurityDialog: boolean;
  @Prop()
  emailSecurityDetail: any;
  dcOptions: any[] = [];
  emailSecurity: {
    autoDomain: string,
    adminEmail: string,
    companyName: string,
    dataCenter: string,
  } = {
    dataCenter: '',
    autoDomain: '',
    adminEmail: '',
    companyName: '',
  };
  submitted: boolean = false;
  errorMessage: string = '';
  mounted() {
    this.emailSecurity = {
      dataCenter: this.emailSecurityDetail.dataCenterLocationId,
      autoDomain: this.emailSecurityDetail.autoCenterDomain,
      adminEmail: this.emailSecurityDetail.adminEmail,
      companyName: this.emailSecurityDetail.company,
    };
    this.dcOptions = this.emailSecurityDetail.EESDatacenter.map((each: any) => {
      return {
        id: each.dataCenterLocationId,
        label: each.dataCenterName,
        value: each.dataCenterLocationId,
      };
    });
  }
  closeDialog() {
    this.$emit('closeDialog');
  }
  validateForm() {
    this.submitted = true;
    this.errorMessage = '';
    this.$v.$touch();
    if (this.$v.$invalid) {
    } else {
      const request = {
        autoDomain: this.emailSecurity.autoDomain,
        datacenter: this.emailSecurity.dataCenter,
        email: this.emailSecurity.adminEmail,
        company: this.emailSecurity.companyName,
      };
      this.$emit('closeDialog', request);
    }
  }
  setDC(dc: string) {
    this.emailSecurity.dataCenter = dc;
  }
}
